import React from "react";
import { Link } from "react-router-dom";
import { Helmet } from "react-helmet";

function PageNotFound() {
    return (
        <div className="min-h-[75vh] flex items-center justify-center px-6 bg-[#fcfaff] dark:bg-[#181d33] text-gray-900 dark:text-white">
            <Helmet>
                <meta charSet="utf-8" />
                <title>404 — Page not found · Content Flash AI</title>
                <meta name="description" content="Content Flash AI — generate blogs, emails, and forms in seconds." />
            </Helmet>

            <div className="text-center max-w-xl">
                <p className="font-display font-bold text-indigo-600 dark:text-indigo-400 leading-none text-[6.5rem] sm:text-[8rem]">
                    404
                </p>

                <h1 className="mt-2 text-2xl sm:text-3xl font-semibold">
                    This page went to generate content… and never came back.
                </h1>

                <p className="mt-4 text-gray-500 dark:text-gray-400 leading-relaxed">
                    Our AI whips up blogs, emails, and forms in seconds — but even it couldn't find
                    this one. It's either moved, deleted, or never existed (bold of you to try). ⚡
                </p>

                <div className="mt-8 flex flex-wrap items-center justify-center gap-3">
                    <Link
                        to="/"
                        className="px-5 py-2.5 rounded-xl bg-indigo-600 hover:bg-indigo-700 text-white font-semibold no-underline shadow-sm shadow-indigo-600/20 transition"
                    >
                        Back to dashboard
                    </Link>
                    <Link
                        to="/support"
                        className="px-5 py-2.5 rounded-xl border border-gray-300 dark:border-gray-600 text-gray-700 dark:text-gray-200 font-medium no-underline hover:bg-gray-100 dark:hover:bg-gray-800 transition"
                    >
                        Get help
                    </Link>
                </div>

                <p className="mt-8 text-sm text-gray-600 dark:text-gray-400 dark:text-gray-500">
                    Error 404 · Lost somewhere in the flash
                </p>
            </div>
        </div>
    );
}

export default PageNotFound;
